import { render } from "./BaseSkillBadge.vue?vue&type=template&id=55eb0fd8&scoped=true"
import script from "./BaseSkillBadge.vue?vue&type=script&lang=js"
export * from "./BaseSkillBadge.vue?vue&type=script&lang=js"

import "./BaseSkillBadge.vue?vue&type=style&index=0&id=55eb0fd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55eb0fd8"

export default script